import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Grid,
  TextField,
  MenuItem
} from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  nombre1: Yup.string().required("Requerido"),
  apellido1: Yup.string().required("Requerido"),
  correo: Yup.string().email("Correo inválido").required("Requerido"),
  tipoIdentificacion: Yup.number().required("Requerido"),
  identificacion: Yup.string().required("Requerido")
});

const FormularioRegistroUsuario = ({
  open,
  onClose,
  onSubmit,
  googleData,
  tiposIdentificacion
}) => {
  return (
    <Formik
      initialValues={{
        nombre1: googleData.nombre1,
        nombre2: googleData.nombre2 || "",
        apellido1: googleData.apellido1 || "",
        apellido2: googleData.apellido2 || "",
        correo: googleData.correo || "",
        identificacion: "",
        tipoIdentificacion: "",
        perfil: "",
        celular: "",
        fijo: "",
        direccion: "",
        masInformacion: "",
        fotoPerfil: googleData.foto_perfil || "",
        activo: true,
        claveEncriptada: '',
        claveHash: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmit(values);
      }}
    >
      {({ values, handleChange, touched, errors }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Primer Nombre"
                name="nombre1"
                fullWidth
                value={values.nombre1}
                onChange={handleChange}
                error={touched.nombre1 && Boolean(errors.nombre1)}
                helperText={touched.nombre1 && errors.nombre1}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Segundo Nombre"
                name="nombre2"
                fullWidth
                value={values.nombre2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Primer Apellido"
                name="apellido1"
                fullWidth
                value={values.apellido1}
                onChange={handleChange}
                error={touched.apellido1 && Boolean(errors.apellido1)}
                helperText={touched.apellido1 && errors.apellido1}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Segundo Apellido"
                name="apellido2"
                fullWidth
                value={values.apellido2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Correo"
                name="correo"
                type="email"
                fullWidth
                value={values.correo}
                onChange={handleChange}
                error={touched.correo && Boolean(errors.correo)}
                helperText={touched.correo && errors.correo}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Celular"
                name="celular"
                fullWidth
                value={values.celular}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                label="Tipo de Identificación"
                name="tipoIdentificacion"
                fullWidth
                value={values.tipoIdentificacion}
                onChange={handleChange}
                error={touched.tipoIdentificacion && Boolean(errors.tipoIdentificacion)}
                helperText={touched.tipoIdentificacion && errors.tipoIdentificacion}
              >
                {tiposIdentificacion.map((tipo) => (
                  <MenuItem key={tipo.id} value={tipo.id}>
                    {tipo.nombreLargo}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Identificación"
                name="identificacion"
                fullWidth
                value={values.identificacion}
                onChange={handleChange}
                error={touched.identificacion && Boolean(errors.identificacion)}
                helperText={touched.identificacion && errors.identificacion}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Teléfono Fijo"
                name="fijo"
                fullWidth
                value={values.fijo}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Dirección"
                name="direccion"
                fullWidth
                value={values.direccion}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Button onClick={onClose} color="secondary">
            Cancelar
          </Button>
          <Button type="submit" color="primary">
            Crear Usuario
          </Button>
        </Form>
      )}
    </Formik >
  );
};

FormularioRegistroUsuario.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  googleData: PropTypes.object,
  perfiles: PropTypes.array.isRequired,
  tiposIdentificacion: PropTypes.array.isRequired
};

export default FormularioRegistroUsuario;